import * as React from "react";
import type { SVGProps } from "react";

interface BreakawayProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Breakaway = ({ cancelled = false, ...props }: BreakawayProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd" transform="translate(.25 3.27)">
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M16.25 0a3.23 3.23 0 0 1 1.17 6.23l.47.06c1.16.14 1.47 1.3 1.07 2.08l-.05.08.1.02a5.4 5.4 0 0 1 4.14 5.04v.21a5.4 5.4 0 0 1-10.31 2.25l-.08-.18v.05a1.4 1.4 0 0 1-1.26 1.4H9.45c-.31 0-.6-.1-.83-.26H3.25a1.26 1.26 0 0 1-.33-2.47l-.67-.03a1.26 1.26 0 0 1-.15-2.5h-.85a1.26 1.26 0 0 1-.15-2.5 1.26 1.26 0 0 1 .02-2.5l.37-.02A1.26 1.26 0 0 1 .5 5.72c0-.69.56-1.25 1.25-1.25H3.1A1.26 1.26 0 0 1 2 3.24c0-.7.56-1.25 1.25-1.25h7.64l.1-.03c.87-.15 1.64.07 2.1.63A3.22 3.22 0 0 1 16.25 0"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M4.75 5.22a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm1.5-2.49a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm-3 4.99a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm2 5a.5.5 0 1 1 0 1h-3a.5.5 0 1 1 0-1zm-2-2.5a.5.5 0 1 1 0 1h-2a.5.5 0 1 1 0-1zm3 5a.5.5 0 1 1 0 1h-3a.5.5 0 1 1 0-1z"
      />
      <circle cx={17.75} cy={13.72} r={4} stroke="#000" strokeWidth={1.3} />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M17.75 13.72a12.9 12.9 0 0 1-2.13-5l-5.17 3.98"
      />
      <path
        fill="#60B100"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M8 11.44c-1.29-.11-2.1-.41-2.45-.9-.52-.73.01-2.49.28-2.85.18-.24.68-.23 1.49.02l2.5 2.51c1.17 2.87 1.39 4.4.66 4.6s-1.56-.93-2.49-3.38Z"
      />
      <path
        fill="#60B100"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M12.11 3.7a5.2 5.2 0 0 0 2.14 3.13c.65.36 1.81.65 3.47.85l-4.58-.35c-.56.4-1.92.92-4.08 1.52L5.8 7.7c1.7-2.92 6-5.4 6.3-4.02Z"
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M9.45 15.84h1.91"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M16.25.75a2.47 2.47 0 1 1 0 4.95 2.47 2.47 0 0 1 0-4.95"
      />
      <circle cx={16.25} cy={3.23} r={1.5} fill="#FFE42B" />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Breakaway;
